<ion-app>
  <!-- Menu para móvil -->
  <ion-menu contentId="main-content" side="start" menuId="mobile-menu">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menú</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      @if (menuData && menuData.typeMenu == 'HOME' ){
        <ion-list>
          <ion-item button href="/organizadores" (click)="closeMenu()">
            <ion-label>
              <span class="icon">📁</span> Organizadores
            </ion-label>
          </ion-item>

          <ion-item button href="/eventos" (click)="closeMenu()">
            <ion-label>
              <span class="icon">📅</span> Eventos
            </ion-label>
          </ion-item>

          @if (isAdmin()) {
            <ion-item-divider>
              <ion-label>Configuraciones</ion-label>
            </ion-item-divider>

            <ion-item button [routerLink]="['/admin/config']" routerLinkActive="active" (click)="closeMenu()">
              <ion-label>
                <span class="icon">⚙️</span> Ajustes Generales
              </ion-label>
            </ion-item>

          <ion-item button [routerLink]="['/admin/email-templates']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">📧</span> Plantillas de Correo
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/ticket-templates']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">🎫</span> Plantillas de Tickets
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/template-forms']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">📝</span> Plantillas de Formulario
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/seatmaps']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">🪑</span> Mapas de Asientos
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/facturadores']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">💰</span> Agentes de Facturación
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/categorias-eventos']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">🏷️</span> Categorías de Eventos
            </ion-label>
          </ion-item>

          <ion-item-divider>
            <ion-label>Seguridad</ion-label>
          </ion-item-divider>

          <ion-item button [routerLink]="['/admin/users']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">👥</span> Usuarios
            </ion-label>
          </ion-item>

          <ion-item button [routerLink]="['/admin/clientes']" routerLinkActive="active" (click)="closeMenu()">
            <ion-label>
              <span class="icon">🧾</span> Clientes
            </ion-label>
          </ion-item>

          }
        </ion-list>
      } @else if (menuData && menuData.typeMenu == 'ORGANIZADOR' ){
        <!-- Contenido para Organizador -->
        <ion-list>
        </ion-list>
      } @else if (menuData && menuData.typeMenu == 'EVENTOS' ){
        <ion-list>
          <ion-item button [routerLink]="['/eventos']" (click)="closeMenu()">
            <ion-label>
              <span class="icon">⬅️</span> Regresar
            </ion-label>
          </ion-item>

          <ion-item-divider (click)="goTo('/eventos', eventData?.eventoid)" style="cursor: pointer;">
            <ion-label>
              <h2><strong>{{eventData?.nombre}}</strong></h2>
            </ion-label>
          </ion-item-divider>

          @if (canAccessEventoDashboard()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid]" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">📊</span> Dashboard
              </ion-label>
            </ion-item>
          }

          @if (canAccessEventoInfoBasica()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'edit']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">📝</span> Info Básica
              </ion-label>
            </ion-item>
          }

          @if (canAccessEventoConfiguracionesAvanzadas()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'configuraciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">⚙️</span> Configuraciones Adicionales
              </ion-label>
            </ion-item>
          }

          @if (canGestionarEvento()) {
            <ion-item-divider>
              <ion-label>Gestión</ion-label>
            </ion-item-divider>

            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'ubicaciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">📍</span> Ubicaciones
              </ion-label>
            </ion-item>

            @if (eventData?.aplica_rubros) {
              <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'rubros']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">
                <ion-label>
                  <span class="icon">🏷️</span> Rubros
                </ion-label>
              </ion-item>
            }

            @if (eventData?.tipoevento === 'tren') {
              <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'subeventos']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">
                <ion-label>
                  <span class="icon">🚂</span> Subeventos
                </ion-label>
              </ion-item>
            }

            @if (eventData?.tipoevento !== 'tren') {
              <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'tipos-ticket']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
                <ion-label>
                  <span class="icon">🎟️</span> Tipos de Ticket
                </ion-label>
              </ion-item>
            }

            @if (eventData?.tipoevento !== 'tren') {
              <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'listas-tickets']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
                <ion-label>
                  <span class="icon">📋</span> Listas de Tickets
                </ion-label>
              </ion-item>
            }

            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'validadores']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">👥</span> Validadores
              </ion-label>
            </ion-item>
          }

          @if (eventData?.tipoevento === 'tren' && canViewFunciones()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'funciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">🗓️</span> Funciones
              </ion-label>
            </ion-item>
          }

          @if (canViewVentas()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'ventas']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">💰</span> Ventas
              </ion-label>
            </ion-item>
          }

          @if (canViewHistorialCarritos()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'historial-carritos']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">🛒</span> Historial Carritos
              </ion-label>
            </ion-item>
          }

          @if (canViewReportes()) {
            <ion-item button [routerLink]="['/eventos', eventData?.eventoid, 'reportes']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
              <ion-label>
                <span class="icon">📈</span> Reportes
              </ion-label>
            </ion-item>
          }
        </ion-list>
      }
    </ion-content>
  </ion-menu>

  <!-- Header que ocupa el 100% del ancho -->
  <ion-header>
    <ion-toolbar class="full-width-toolbar">
      <!-- Hamburger button para móvil -->
      <ion-buttons slot="start" class="mobile-menu-button">
        <ion-menu-button menu="mobile-menu"></ion-menu-button>
      </ion-buttons>

      <div class="header-content">
        <ion-title class="header-title"><a routerLink="/" class="header-title-link"><span *ngIf="envName !== 'production'" class="env-badge">{{ envName | uppercase }}</span> TicketExito</a></ion-title>

        <!-- <nav class="desktop-nav">
          <a [routerLink]="'/home'" routerDirection="root" class="nav-link-custom" 
             >Inicio</a>
          <a [routerLink]="'/profile'" routerDirection="root" class="nav-link-custom"
             >Perfil</a>
          <a [routerLink]="'/settings'" routerDirection="root" class="nav-link-custom"
             >Configuración</a>
        </nav> -->
      </div>

      <!-- Botones de usuario - solo visible en desktop -->
      <ion-buttons slot="end" class="desktop-user-buttons">

        <app-user-dropdown></app-user-dropdown>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <!-- Contenido Principal -->
  <ion-content class="main-content" id="main-content">
    <div class="content-wrapper">


      <aside class="sidebar dashboard-sidebar">
        @if (menuData && menuData.typeMenu == 'HOME' ){
        <div class="sidebar-header">
          <h2 (click)="goHome()" style="cursor: pointer;">Dashboard</h2>
        </div>

        <nav class="sidebar-nav">
          <ul>
            <li>
              <a href="/organizadores">
                <span class="icon">📁</span>
                Organizadores
              </a>
            </li>

            <li>
              <a href="/eventos">
                <span class="icon">📅</span>
                Eventos
              </a>
            </li>

            @if (isAdmin()) {
              <li class="section-title">Configuraciones</li>

              <li>
                <a [routerLink]="['/admin/config']" routerLinkActive="active">
                  <span class="icon">⚙️</span>
                  Ajustes Generales
                </a>
              </li>

            <li>
              <a [routerLink]="['/admin/email-templates']" routerLinkActive="active">
                <span class="icon">📧</span>
                Plantillas de Correo
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/ticket-templates']" routerLinkActive="active">
                <span class="icon">🎫</span>
                Plantillas de Tickets
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/template-forms']" routerLinkActive="active">
                <span class="icon">📝</span>
                Plantillas de Formulario
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/seatmaps']" routerLinkActive="active">
                <span class="icon">🪑</span>
                Mapas de Asientos
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/facturadores']" routerLinkActive="active">
                <span class="icon">💰</span>
                Agentes de Facturación
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/categorias-eventos']" routerLinkActive="active">
                <span class="icon">🏷️</span>
                Categorías de Eventos
              </a>
            </li>

            <li class="section-title">Seguridad</li>

            <li>
              <a [routerLink]="['/admin/users']" routerLinkActive="active">
                <span class="icon">👥</span>
                Usuarios
              </a>
            </li>

            <li>
              <a [routerLink]="['/admin/clientes']" routerLinkActive="active">
                <span class="icon">🧾</span>
                Clientes
              </a>
            </li>

            
            }
          </ul>
        </nav>
        } @else if (menuData && menuData.typeMenu == 'ORGANIZADOR' ){


        } @else if (menuData && menuData.typeMenu == 'EVENTOS' ){
        <nav class="sidebar-nav">
          <ul>
            <li>
              <a [routerLink]="['/eventos']">
                <span class="icon">⬅️</span>
                Regresar
              </a>
            </li>
          </ul>
        </nav>

        <div class="sidebar-header" [routerLink]="['/eventos', eventData?.eventoid]" style="cursor: pointer;">
          <h2>{{eventData?.nombre}}</h2>
        </div>

        <nav class="sidebar-nav">
          <ul>
            @if (canAccessEventoDashboard()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid]" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">📊</span>
                  Dashboard
                </a>
              </li>
            }

            @if (canAccessEventoInfoBasica()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'edit']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">📝</span>
                  Info Básica
                </a>
              </li>
            }

            @if (canAccessEventoConfiguracionesAvanzadas()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'configuraciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">⚙️</span>
                  Configuraciones Adicionales
                </a>
              </li>
            }

            @if (canGestionarEvento()) {
              <li class="section-title">Gestión</li>

              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'ubicaciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                  <span class="icon">📍</span>
                  Ubicaciones
                </a>
              </li>

              @if (eventData?.aplica_rubros) {
                <li>
                  <a [routerLink]="['/eventos', eventData?.eventoid, 'rubros']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                    <span class="icon">🏷️</span>
                    Rubros
                  </a>
                </li>
              }

              @if (eventData?.tipoevento === 'tren') {
                <li>
                  <a [routerLink]="['/eventos', eventData?.eventoid, 'subeventos']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                    <span class="icon">🚂</span>
                    Subeventos
                  </a>
                </li>
              }

              @if (eventData?.tipoevento !== 'tren') {
                <li>
                  <a [routerLink]="['/eventos', eventData?.eventoid, 'tipos-ticket']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <span class="icon">🎟️</span>
                    Tipos de Ticket
                  </a>
                </li>
              }

              @if (eventData?.tipoevento !== 'tren') {
                <li>
                  <a [routerLink]="['/eventos', eventData?.eventoid, 'listas-tickets']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <span class="icon">📋</span>
                    Listas de Tickets
                  </a>
                </li>
              }

              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'validadores']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">👥</span>
                  Validadores
                </a>
              </li>
            }

            @if (eventData?.tipoevento === 'tren' && canViewFunciones()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'funciones']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                  <span class="icon">🗓️</span>
                  Funciones
                </a>
              </li>
            }

            @if (canViewVentas()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'ventas']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">💰</span>
                  Ventas
                </a>
              </li>
            }

            @if (canViewHistorialCarritos()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'historial-carritos']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">🛒</span>
                  Historial Carritos
                </a>
              </li>
            }

            @if (canViewReportes()) {
              <li>
                <a [routerLink]="['/eventos', eventData?.eventoid, 'reportes']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="icon">📈</span>
                  Reportes
                </a>
              </li>
            }
          </ul>
        </nav>
        }

      </aside>
      <main class="dashboard-main">
        <router-outlet></router-outlet>
      </main>
    </div>
  </ion-content>
  <!-- <ion-footer>
    <ion-toolbar>
      <ion-title class="footer-title">© 2024 TicketExito. Todos los derechos reservados.</ion-title>
    </ion-toolbar>
  </ion-footer> -->
</ion-app>